module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<ul>\n<%\nvar lastIndex = model.breadCrumbs.length - 1;\nfor(var b in model.breadCrumbs){\n%>\n<li data-route=\"<%- (b != lastIndex ? model.breadCrumbs[b].path : '') %>\"><%= model.breadCrumbs[b].name %></li>\n<%\nif(b != lastIndex){\n%>\n<div class=\"separator\">/</div>\n<%\n}\n}\n%>\n</ul>"
  , __filename = "components/templates/headPanel/breadCrumbs.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<ul>\n")
    ; __line = 2
    ; 
var lastIndex = model.breadCrumbs.length - 1;
for(var b in model.breadCrumbs){

    ; __line = 5
    ; __append("\n<li data-route=\"")
    ; __line = 6
    ; __append( (b != lastIndex ? model.breadCrumbs[b].path : '') )
    ; __append("\">")
    ; __append(escapeFn( model.breadCrumbs[b].name ))
    ; __append("</li>\n")
    ; __line = 7
    ; 
if(b != lastIndex){

    ; __line = 9
    ; __append("\n<div class=\"separator\">/</div>\n")
    ; __line = 11
    ; 
}
}

    ; __line = 14
    ; __append("\n</ul>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/headPanel/breadCrumbs.ejs

}